import React from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';
import logo from './assets/ixl_marketing_logo2.png';

const Navigation = () => {
  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img src={logo} alt="IXL Marketing Solutions" />
        </Link>
        
        {/* Desktop Menu */}
        <ul className="nav-menu desktop-only">
          <li><Link to="/services">Services</Link></li>
          <li><Link to="/results">Results</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
        
        <Link to="/contact" className="nav-cta desktop-only">Get Started</Link>
      </div>
    </nav>
  );
};

export default Navigation;
